import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';
import { Icon, Translate } from '@hydra/common/components';
import StyleButton from './StyleButton';

// Available BLOCK_TYPES:
// { label: 'H1', style: 'header-one' },
// { label: 'H2', style: 'header-two' },
// { label: 'H3', style: 'header-three' },
// { label: 'H4', style: 'header-four' },
// { label: 'H5', style: 'header-five' },
// { label: 'H6', style: 'header-six' },
// { label: 'Blockquote', style: 'blockquote' },
// { label: 'Code Block', style: 'code-block' }

const useStyles = makeStyles(theme => ({
  mr4: {
    marginRight: theme.spacing(0.75)
  }
}));

export const BlockStyleControls = (props) => {
  const { editorState, onToggle } = props;
  const classes = useStyles();
  const selection = editorState.getSelection();

  const BLOCK_TYPES = [
    {
      label: (
        <>
          <Icon className={classes.mr4} size='md' color='grey-light' type='list-ul' />
          <Translate content='bullet_list' />
        </>
      ),
      style: 'unordered-list-item'
    },
    {
      label: (
        <>
          <Icon className={classes.mr4} size='md' color='grey-light' type='list-ol' />
          <Translate content='numbered_list' />
        </>
      ),
      style: 'ordered-list-item'
    }
  ];

  const blockType = editorState
    .getCurrentContent()
    .getBlockForKey(selection.getStartKey())
    .getType();

  return (
    <div>
      {
        BLOCK_TYPES.map((type) =>
          <StyleButton
            key={type.style}
            active={type.style === blockType}
            label={type.label}
            onToggle={onToggle}
            style={type.style}
          />
        )
      }
    </div>
  );
};

BlockStyleControls.propTypes = {
  editorState: PropTypes.object.isRequired,
  onToggle: PropTypes.func.isRequired
};

export default BlockStyleControls;
